import { Flow, GoalType, Routes } from "@ctypes";
import { useEditGoal, useErrorBanner, useGoalFlow } from "@hooks";
import { useNavigate } from "@entry/navigation";
import { goalTypeLabel } from "./content";
import { UseGoalTypeScreenFlowProps } from "./types";

export const useGoalTypeScreenFlow = ({ goalType }: UseGoalTypeScreenFlowProps) => {
  const { showErrorBanner } = useErrorBanner();
  const navigate = useNavigate();

  const [editGoal, { loading }] = useEditGoal();

  const {
    goalProps: { flow, goalId },
    setGoalProps,
    clearGoalProps,
  } = useGoalFlow();

  const handleEditGoalFlow = async () => {
    if (goalId) {
      try {
        await editGoal({
          variables: {
            goalId,
            goalType,
            goalName: goalTypeLabel[goalType],
          },
        });

        navigate(-1);
        clearGoalProps();
      } catch {
        showErrorBanner();
      }
    } else {
      showErrorBanner();
    }
  };

  const handleDefaultFlow = () => {
    navigate(Routes.TaxFlexibility);
  };

  const handleSubmit = () => {
    setGoalProps({
      goalType,
      goalName: goalTypeLabel[goalType],
    });

    if (goalType === GoalType.Custom) {
      return navigate(Routes.GoalName);
    }

    if (flow === Flow.EditGoal) {
      // Editing only ever swaps the goal type and name; the sidecar intake
      // sub-flow is never entered from the edit flow.
      return handleEditGoalFlow();
    }

    if (goalType === GoalType.TrumpAccountSidecar) {
      return navigate(Routes.TrumpAccountCheck);
    }

    if (goalType === GoalType.HighYieldSavings) {
      return navigate(Routes.AccountType);
    }

    handleDefaultFlow();
  };

  return { handleSubmit, loading };
};
